import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/domains';
import { ASSIGNMENT_CONFIGURATION_REPOSITORY } from '../../core';
import { ASSIGNMENT_CONFIGURATION_API, ASSIGNMENT_CONFIGURATION_CACHED } from '../data-sources';
export var AssignmentConfigurationRepository = /*#__PURE__*/function () {
  function AssignmentConfigurationRepository(assignmentConfigurationApi, assignmentConfigurationCached) {
    _classCallCheck(this, AssignmentConfigurationRepository);

    this.assignmentConfigurationApi = assignmentConfigurationApi;
    this.assignmentConfigurationCached = assignmentConfigurationCached;
  }

  _createClass(AssignmentConfigurationRepository, [{
    key: "getMany",
    value: function () {
      var _getMany = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(queryParams) {
        var cachedData, responseOrError, assignmentConfigsResponse;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cachedData = this.assignmentConfigurationCached.getAssignmentConfigurationCached(queryParams.locale);

                if (!cachedData) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Result.ok(cachedData));

              case 3:
                _context.next = 5;
                return this.assignmentConfigurationApi.getAssignmentConfigurations(queryParams);

              case 5:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 8:
                assignmentConfigsResponse = responseOrError.getValue();
                this.assignmentConfigurationCached.setAssignmentConfigurationCached(assignmentConfigsResponse, queryParams.locale);
                return _context.abrupt("return", Result.ok(assignmentConfigsResponse));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getMany(_x) {
        return _getMany.apply(this, arguments);
      }

      return getMany;
    }()
  }]);

  return AssignmentConfigurationRepository;
}();
export var assignmentConfigurationRepositoryProvider = {
  provide: ASSIGNMENT_CONFIGURATION_REPOSITORY,
  useFactory: function useFactory(assignmentConfigurationApi, assignmentConfigurationCached) {
    return new AssignmentConfigurationRepository(assignmentConfigurationApi, assignmentConfigurationCached);
  },
  inject: [ASSIGNMENT_CONFIGURATION_API, ASSIGNMENT_CONFIGURATION_CACHED]
};